export class Step3 {
	public intitule = 'stepper.form.simp_at.step3';

	public getintitule = 'form.simp_at.getintitule';
	public getspan2 = 'form.simp_at.getspan2';
	public getclassprincipale = 'form.simp_at.getclassprincipale';
	public getclasssupplementaire = 'form.simp_at.getclasssupplementaire';
	public getspan4 = 'form.simp_at.getspan4';
	public getspan5 = 'form.simp_at.getspan5';
	public gettravaux = 'form.simp_at.gettravaux';
	public getfournitures = 'form.simp_at.getfournitures';
	public getservices = 'form.simp_at.getservices';
	public getdescription = 'form.simp_at.getdescription';
	public getmotclef = 'form.simp_at.getmotclef_liste_avi_';
}
